import React from 'react';
import BookingTabs from './Tabs';

function Bookings() {
    return <BookingTabs />;
}

export default React.memo(Bookings);
